export default function getActivityTimeAsUtc(time: string): Date {
  return new Date(`${time}Z`);
}
